import { faTrash } from '@fortawesome/free-solid-svg-icons'
import type { FC } from 'react'

import ActionButton from './ActionButton'

interface Props {
  onClick: () => void
  disabled?: boolean
}

const RemoveButton: FC<Props> = ({ onClick, disabled = false }) => (
  <ActionButton label="Remove" icon={faTrash} onClick={onClick} disabled={disabled} />
)

export default RemoveButton
